import { LogErrors } from './../LogErrors'

import { UpdateSessionInfo } from './../DL/Sessions'


const rolesData = {
    ZTUDIANTE: 1,
    INSTRUCTOR: 2,
    PROGRESS: 3
}

//----- Ztudiante -----//

const SaveCourseToShow = async (session, element, goToQuickAccessInstrument = false, role = rolesData.ZTUDIANTE) => {
    try {
        if (role === rolesData.ZTUDIANTE) {
            session.navigation.course = {
                "id": element.id,
                "name": element.name,
                "type": element.type,
                "level": element.level,
                "goToQuickAccessInstrument": goToQuickAccessInstrument,
                "urlToBack": '/dashboard'
            }
            
        } else if (role === rolesData.INSTRUCTOR) {
            session.navigation.course = {
                "id": element.idCourse,
                "name": element.nameCourse,
                "type": element.idType, // Lo va a agregar Enrique
                "level": element.idLevel, // Lo va a agregar Enrique
                "goToQuickAccessInstrument": goToQuickAccessInstrument,
                "urlToBack": '/dashboard'
            }

        } else if (role === rolesData.PROGRESS) {
            session.navigation.course = {
                "id": element.idCourse,
                "name": element.nameCourse,
                "type": element.idType, // Lo va a agregar Enrique
                "level": element.idLevel, // Lo va a agregar Enrique
                "goToQuickAccessInstrument": goToQuickAccessInstrument,
                "idUser": element.idUser,
                "urlToBack": '/instructor/progress'
            }
        }
        
        const response = await UpdateSessionInfo(session)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('SaveCourseToShow - Navigation BL', error)
        return { success: false, message: '' }
    }
}

const ResetCourseToShow = async (session) => {
    try {
        if (session.navigation === undefined || session.navigation === null) {
            return { success: true, data: session }
        }
        
        if (session.navigation.course === undefined || session.navigation.course === null) {
            return { success: true, data: session }
        }

        session.navigation.course = null

        const response = await UpdateSessionInfo(session)
            
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // if (session.navigation === undefined) {
        //     return { success: true, data: session }
        // } else {
        //     session.navigation = null
            
        //     const response = await UpdateSessionInfo(session)
            
        //     if (response.success) {
        //         return { success: true, data: response.data }
        //     } else {
        //         return { success: false, message: response.message }
        //     }
        // }
    } catch (error) {
        await LogErrors('ResetCourseToShow - Navigation BL', error)
        return { success: false, message: '' }
    }
}

const SaveInstrumentToShow = async (session, _instrument) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        
        const navigation = userData?.navigation
        if (!navigation) {
            return { success: false, message: 'No ha sido posible mostrar el instrumento solicitado. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        userData.navigation.instrument = {
            "id": _instrument.id,
            "name": _instrument.name,
            "type": _instrument.type,
            "enabled": _instrument?.enabled || null,
            "time": _instrument?.evaluation?.totalTime || null,
            "questions": _instrument?.evaluation?.totalQuestions || null
        }
        
        const response = await UpdateSessionInfo(userData)
        // 
        // session.navigation.instrument = {
        //     "id": instrument.id,
        //     "name": instrument.name,
        //     "type": instrument.type,
        //     "enabled": instrument?.enabled || null
        // }
        // const response = await UpdateSessionInfo(session)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('SaveInstrumentToShow - Navigation BL', error)
        return { success: false, message: '' }
    }
}

const ResetInstrumentToShow = async (session) => {
    try {
        if (session.navigation.instrument === undefined) {
            return { success: true, data: session }
        } else {
            session.navigation.instrument = null
            
            const response = await UpdateSessionInfo(session)

            if (response.success) {
                return { success: true, data: response.data }
            } else {
                return { success: false, message: response.message }
            }
        }
    } catch (error) {
        await LogErrors('ResetInstrumentToShow - Navigation BL', error)
        return { success: false, message: '' }
    }
}

// const SaveLearningInstrumentsToShow = async (session, learningInstrumentId) => {
//     try {
//         session.navigation.instruments = {
//             "item": {
//                 "id": learningInstrumentId
//             }
//         }
        
//         const response = await UpdateSessionInfo(session)

//         if (response.success) {
//             return { success: true, data: response.data }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
//         await LogErrors('SaveLearningInstrumentsToShow - Navigation BL', error)
//         return { success: false, message: '' }
//     }
// }

// const SaveActivityToShow = async (session, idActivity) => {
//     try {
//         session.navigation.activity = {
//             "item": {
//                 "id": idActivity
//             }
//         }
        
//         const response = await UpdateSessionInfo(session)

//         if (response.success) {
//             return { success: true, data: response.data }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
//         await LogErrors('SaveActivityToShow - Navigation BL', error)
//         return { success: false, message: '' }
//     }
// }

const SaveCenterAndRoleToShow = async (session, idCenter, idRole) => {
    try {
        if (session.navigation === undefined || session.navigation === null) {
            session.navigation = {
                "center": {
                    "id": idCenter
                },
                "role": {
                    "id": idRole
                }
            }
        } else {
            session.navigation.center = {
                id: idCenter
            }
            session.navigation.role = {
                id: idRole
            }
        }

        const response = await UpdateSessionInfo(session)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('SaveCenterAndRoleToShow - Navigation BL', error)
        return { success: false, message: '' }
    }
}

const SaveCenterToShow = async (session, center) => {
    try {
        if (!center) {
            return { success: false, message: 'No ha sido posible guardar el centro que elegiste. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        const navigation = session?.navigation
        
        if (navigation) {
            session.navigation.center = {
                id: center.id,
                name: center.name
            }
        } else {
            session.navigation = {
                "center": {
                    "id": center.id,
                    "name": center.name
                }
            }
        }
        
        const response = await UpdateSessionInfo(session)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('SaveCenterToShow - Navigation BL', error)
        return { success: false, message: '' }
    }
}

const SaveRoleToShow = async (session, role) => {
    try {
        if (!role) {
            return { success: false, message: 'No ha sido posible guardar el perfil que elegiste. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const navigation = session?.navigation

        if (navigation) {
            session.navigation.role = {
                id: role.id,
                name: role.name
            }
        } else {
            session.navigation = {
                "role": {
                    "id": role.id,
                    "name": role.name
                }
            }
        }
        
        const response = await UpdateSessionInfo(session)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('SaveRoleToShow - Navigation BL', error)
        return { success: false, message: 'Ha habido un detalle y no ha sido posible guardar el perfil que elegiste. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const ChangeProfile = async () => {
    try {
        // Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: 'No ha sido posible cambiar de centro/perfil. Inténtalo nuevamente o inténtalo más tarde.' } // En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        // Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        
        const navigation = userData?.navigation
        if (!navigation) {
            return { success: false, message: 'No ha sido posible cambiar de centro/perfil. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        const center = navigation?.center
        if (center) {
            userData.navigation.center = null
        } else {
            return { success: false, message: 'No ha sido posible cambiar de centro/perfil. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const role = navigation?.role
        if (role) {
            userData.navigation.role = null
        } else {
            return { success: false, message: 'No ha sido posible cambiar de centro/perfil. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        const response = await UpdateSessionInfo(userData)
        
        if (response.success) {
            return { success: true, data: null }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('ChangeProfile - Navigation BL', error)
        return { success: false, message: '' }
    }
}





const SaveResultCourseToShow = async (session, idCourse) => {
    try {
        if (session.navigation === undefined || session.navigation === null) {
            session.navigation = {
                "result": {
                    "course": idCourse
                }
            }
        } else {
            session.navigation.result = {
                "course": idCourse
            }
        }

        const response = await UpdateSessionInfo(session)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('SaveResultCourseToShow - Navigation BL', error)
        return { success: false, message: '' }
    }
}

const SaveResultItemToShow = async (session, evaluationIndex) => { //idItem
    try {
        const result = session?.navigation?.result
        if (!result) {
            return { success: false, message: '' }
        }

        session.navigation.result.item = evaluationIndex
        
        const response = await UpdateSessionInfo(session)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('SaveResultItemToShow - Navigation BL', error)
        return { success: false, message: '' }
    }
}

const SaveQuickAccessResultToShow = async (session, idCourse, idItem) => {
    try {
        session.navigation.result = {
            "course": idCourse,
            "item": idItem
        }
        
        const response = await UpdateSessionInfo(session)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('SaveQuickAccessResultToShow - Navigation BL', error)
        return { success: false, message: '' }
    }
}

// const GetAndSetCenterAndRole = async (session) => {
//     try {
//         let center = null
//         let role = null

//         // Revisar si en la propiedad Navigation está el centro seleccionado
//         if (session.navigation !== undefined) {
//             if (session.navigation !== null) {
//                 if (session.navigation.center !== undefined) {
//                     if (session.navigation.center !== null) {
//                         if (session.navigation.center.id !== undefined) {
//                             if (session.navigation.center.id !== null) {
//                                 center = session.navigation.center.id
//                             }
//                         }
//                     }
//                 }
//             }
//         }

//         if (center === null) {
//             // Si NO encontró el centro revisa en la info de Centros
//             // Checa si existe solo un centro para asignarlo directo. En caso contrario, se le enviará a escoger
//             if (session.user.centers.length === 1) {
//                 center = parseInt(session.user.centers[0].id)

//                 // Checa si existe solo un rol para asignarlo directo. En caso contrario, se le enviará a escoger
//                 if (session.user.centers[0].roles.length === 1) {
//                     role = parseInt(session.user.centers[0].roles[0].id)
//                 }
//             }
//         } else {
//             // Si encontró el centro, revisa si en la propiedad Navigation está el rol seleccionado
//             if (session.navigation !== undefined) {
//                 if (session.navigation !== null) {
//                     if (session.navigation.role !== undefined) {
//                         if (session.navigation.role !== null) {
//                             if (session.navigation.role.id !== undefined) {
//                                 if (session.navigation.role.id !== null) {
//                                     role = session.navigation.role.id
//                                 }
//                             }
//                         }
//                     }
//                 }
//             }

//             // Si NO encontró el rol en Navigation revisa en la info de Roles del centro
//             if (role === null) {
//                 const tmpCenter = session.user.centers.find(itemCenter => itemCenter.id === center)

//                 if (tmpCenter) {
//                     // Checa si existe solo un rol para asignarlo directo. En caso contrario, se le enviará a escoger
//                     if (tmpCenter.roles.length === 1) {
//                         role = tmpCenter.roles[0].id
//                     }
//                 }
//             }
//         }

//         return { success: true,
//             data: {
//                 center: center,
//                 role: role
//             }
//         }
//     } catch (error) {
//         await LogErrors('GetCenterAndRole BL Navigation', error)
//     }
// }

const GetAndSetCenterAndRole = async (session) => {
    try {
        let center = null
        let role = null

        if (session?.navigation?.center?.id) {
            center = session.navigation.center.id
        }

        if (!center && session?.user?.centers?.length === 1) {
            center = parseInt(session.user.centers[0].id)

            if (session.user.centers[0]?.roles?.length === 1) {
                role = parseInt(session.user.centers[0].roles[0].id)
            }
        } else if (center && session?.navigation?.role?.id) {
            role = session.navigation.role.id
        }

        if (!role && center) {
            const tmpCenter = session.user.centers.find(itemCenter => itemCenter.id === center)
            if (tmpCenter?.roles?.length === 1) {
                role = tmpCenter.roles[0].id
            }
        }

        return {
            success: true,
            data: {
                center: center,
                role: role
            }
        }
    } catch (error) {
        await LogErrors('GetAndSetCenterAndRole BL Navigation', error)
        return { success: false, message: '' }
    }
}

/**
 * Función que obtiene el alias del usuario
 * @returns 
 */
const GetNickname = async () => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
        
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        
        const nickname = userData?.user?.nickname
        
        if (nickname) {
            return { success: true, data: nickname }
        } else {
            return { success: false, message: 'No ha sido posible obtener el alias del usuario' }
        }
    } catch (error) {
        await LogErrors('GetNickname - Navigation BL', error)
        return { success: false, message: 'No ha sido posible obtener el alias del usuario' }
    }
}

/**
 * Función que obtiene la info del Ztudiante para enviarlo a las dinámicas digitales
 * @returns 
 */
const GetZtudentDataToGames = async (idGame) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
        
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        if (!userData) {
            return { success: false, message: '' }
        }

        const center = userData?.navigation?.center
        if (!center) {
            return { success: false, message: 'No ha sido posible obtener la información del estudiante' }
        }

        const user = userData?.user
        if (!user) {
            return { success: false, message: 'No ha sido posible obtener la información del estudiante' }
        }

        const centerId = userData?.navigation?.center?.id
        const centerName = userData?.navigation?.center?.name
        const username = userData?.navigation?.username

        const name = userData?.user?.name
        const lastname = userData?.user?.lastName
        const nickname = userData?.user?.nickname
        const email = userData?.user?.email

        const ztudentData = {
            centerId: centerId,
            centerName: centerName,
            username: username,
            name: name,
            lastname: lastname,
            nickname: nickname,
            email: email,
            gameIdentifier: ''
        }

        if (!idGame) {
            return { success: false, message: 'No ha sido posible obtener la información del estudiante' }
        }

        switch (idGame) {
            case 1:
                ztudentData.gameIdentifier = 'tiro-a-gol'
                break;
        
            default:
                ztudentData.gameIdentifier = ''
                break;
        }

        return { success: true, data: ztudentData }
    } catch (error) {
        await LogErrors('GetZtudentDataToGames - Navigation BL', error)
        return { success: false, message: 'No ha sido posible obtener la información del estudiante' }
    }
}

//----- Ztudiante -----//


//----- Instructor -----//

const SaveGroupToShow = async (idGroup, groupName) => {
    try {
        // Validar que traigan los datos necesarios
        if (!idGroup || !groupName) {
            return { success: false, message: 'No es posible mostrar la info del grupo deseado. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        
        const group = userData?.navigation?.group
        if (!group) {
            userData.navigation = {
                ...userData.navigation,
                "group": {
                    "id": idGroup,
                    "name": groupName
                }
            }
        } else {
            userData.navigation.group = {
                "id": idGroup,
                "name": groupName
            }
        }
        
        const response = await UpdateSessionInfo(userData)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('SaveResultCourseToShow - Navigation BL', error)
        return { success: false, message: 'No ha sido posible mostrar la info del grupo deseado. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const ResetGroupToShow = async () => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        
        const group = userData?.navigation?.group
        if (group) {
            userData.navigation.group = null
        }
        
        const response = await UpdateSessionInfo(userData)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('ResetGroupToShow - Navigation BL', error)
        //return { success: false, message: 'No ha sido posible resetear la info del grupo.' }
    }
}

/**
 * Función que obtiene la info del centro que eligió el usuario
 * @returns 
 */
const GetCurrentCenter = async () => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
        
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        
        const center = userData?.navigation?.center
        
        if (center) {
            return { success: true, data: center }
        } else {
            return { success: false, message: 'No ha sido posible obtener el centro actual del usuario' }
        }
    } catch (error) {
        await LogErrors('GetCurrentCenter - Navigation BL', error)
        return { success: false, message: 'No ha sido posible obtener el centro actual del usuario' }
    }
}

//----- Instructor -----//



//----- Ztudent Course Item -----//

const ConfigureExam = (evaluationMethod, url, userData, courseId, instrument) => {
    try {
        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }

        const name = userData?.user?.name
        const lastName = userData?.user?.lastName
        if (!name && !lastName) {
            return { success: false, message: '' }
        }
    
        const completeName = `${userData.user.name} ${userData.user.lastName}`

        const centerId = userData?.navigation?.center?.id
        if (!centerId) {
            return { success: false, message: '' }
        }

        const itemId = instrument?.id
        if (!itemId) {
            return { success: false, message: '' }
        }
        
        const time = instrument?.evaluation?.totalTime
        if (!time) {
            return { success: false, message: '' }
        }

        const questions = instrument?.evaluation?.totalQuestions
        if (!questions) {
            return { success: false, message: '' }
        }
        
        let urlParameters = `?ndhshrksa=${token}&lsjkrnfber=${completeName}&adkenakddwo=${centerId}&urhsbkdnbfsd=${courseId}&pbsgrjskjrae=${itemId}&wrtdjslgdakr=${time}&vbnwejrskawd=${questions}`

        return {
            method: evaluationMethod,
            url: `${url}/${urlParameters}`
        }
    } catch (error) {
        
    }
}

/**
 * Función que obtiene el tipo de examen que se desea presentar (Normal, Teórico o WebApps) para redirigirlo a donde corresponda
 * @param {*} instrument 
 * @returns 
 */
const GetEvaluationMethod = async (instrument) => {
    try {
        const evaluationMethods = {
            DESKTOP: 1,
            THEORIST: 2,
            WEBAPPS: 3
        }

        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
        
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        if (!userData) {
            return { success: false, message: '' }
        }
        
        const courseId = userData?.navigation?.course?.id
        if (!courseId) {
            return { success: false, message: '' }
        }

        let examData = {}
        

        // ID's para el curso de Principios de Programación
        if (courseId === 16 || courseId === 555 || courseId === 556 || courseId === 558 || courseId === 561 || courseId === 562 || courseId === 563 || courseId === 564 || courseId === 44 || courseId === 149 || courseId === 150 || courseId === 151 || courseId === 152 || courseId === 153 || courseId === 160 || courseId === 173 || courseId === 180 || courseId === 186 || courseId === 192 || courseId === 206 || courseId === 254 || courseId === 270 || courseId === 280 || courseId === 290 || courseId === 295 || courseId === 300 || courseId === 317 || courseId === 318 || courseId === 341 || courseId === 355 || courseId === 364 || courseId === 402 || courseId === 430 || courseId === 446 || courseId === 482 || courseId === 500 || courseId === 514 || courseId === 579 || courseId === 536 || courseId === 538 || courseId === 611 || courseId === 689 || courseId === 727 || courseId === 866 || courseId === 914 || courseId === 15 || courseId === 166 || courseId === 651 || courseId === 664 || courseId === 673 || courseId === 682 || courseId === 713 || courseId === 731 || courseId === 738 || courseId === 745 || courseId === 752 || courseId === 759 || courseId === 766 || courseId === 773 || courseId === 780 || courseId === 797 || courseId === 805 || courseId === 809 || courseId === 814 || courseId === 893 || courseId === 897 || courseId === 904 || courseId === 911 || courseId === 920 || courseId === 937 || courseId === 944 || courseId === 953 || courseId === 984 || courseId === 996 || courseId === 1004 || courseId === 1084 || courseId === 1085 || courseId === 1049 || courseId === 1090 || courseId === 1098 || courseId === 1109 || courseId === 1118) {
            examData = await ConfigureExam(evaluationMethods.THEORIST, 'https://eval.ztudia.com', userData, courseId, instrument)
            
            // const token = userData?.token
            // if (!token) {
            //     return { success: false, message: '' }
            // }
    
            // const name = userData?.user?.name
            // const lastName = userData?.user?.lastName
            // if (!name && !lastName) {
            //     return { success: false, message: '' }
            // }
        
            // const completeName = `${userData.user.name} ${userData.user.lastName}`
    
            // const centerId = userData?.navigation?.center?.id
            // if (!centerId) {
            //     return { success: false, message: '' }
            // }
    
            // const itemId = instrument?.id
            // if (!itemId) {
            //     return { success: false, message: '' }
            // }
            
            // let urlParameters = `?ndhshrksa=${token}&lsjkrnfber=${completeName}&adkenakddwo=${centerId}&urhsbkdnbfsd=${courseId}&pbsgrjskjrae=${itemId}`
            
            // examData = {
            //     method: evaluationMethods.THEORIST,
            //     url: `https://eval.ztudia.com/${urlParameters}`
            // }

        // ID's para el curso de POO
        } else if (courseId === 20 || courseId === 45 || courseId === 158 || courseId === 162 || courseId === 174 || courseId === 182 || courseId === 188 || courseId === 208 || courseId === 357 || courseId === 484 || courseId === 493 || courseId === 501 || courseId === 606 || courseId === 665 || courseId === 672 || courseId === 733 || courseId === 740 || courseId === 747 || courseId === 754 || courseId === 761 || courseId === 768 || courseId === 775 || courseId === 782 || courseId === 19 || courseId === 653 || courseId === 798 || courseId === 894 || courseId === 898 || courseId === 905 || courseId === 912 || courseId === 922 || courseId === 924 || courseId === 927 || courseId === 929 || courseId === 938 || courseId === 945 || courseId === 954 || courseId === 959 || courseId === 982 || courseId === 985 || courseId === 1005 || courseId === 1015 || courseId === 1019 || courseId === 1018 || courseId === 1100) {
            examData = await ConfigureExam(evaluationMethods.THEORIST, 'https://eval.ztudia.com', userData, courseId, instrument)

        } else if (courseId === 559) { // ID's para el curso de Excel WebApps
            examData = await ConfigureExam(evaluationMethods.WEBAPPS, 'https://webapps.ztudia.com', userData, courseId, instrument)

            // const token = userData?.token
            // if (!token) {
            //     return { success: false, message: '' }
            // }
    
            // const name = userData?.user?.name
            // const lastName = userData?.user?.lastName
            // if (!name && !lastName) {
            //     return { success: false, message: '' }
            // }
        
            // const completeName = `${userData.user.name} ${userData.user.lastName}`
    
            // const centerId = userData?.navigation?.center?.id
            // if (!centerId) {
            //     return { success: false, message: '' }
            // }
    
            // const itemId = instrument?.id
            // if (!itemId) {
            //     return { success: false, message: '' }
            // }
            
            // let urlParameters = `?ndhshrksa=${token}&lsjkrnfber=${completeName}&adkenakddwo=${centerId}&urhsbkdnbfsd=${courseId}&pbsgrjskjrae=${itemId}`
            
            // examData = {
            //     method: evaluationMethods.WEBAPPS,
            //     url: `https://evalm.ztudia.com/${urlParameters}`
            // }

        } else if (courseId === 670 || courseId === 671) { // ID's para el curso de Ciudadanía digital
            examData = await ConfigureExam(evaluationMethods.THEORIST, 'https://eval.ztudia.com', userData, courseId, instrument)

            // const token = userData?.token
            // if (!token) {
            //     return { success: false, message: '' }
            // }
    
            // const name = userData?.user?.name
            // const lastName = userData?.user?.lastName
            // if (!name && !lastName) {
            //     return { success: false, message: '' }
            // }
        
            // const completeName = `${userData.user.name} ${userData.user.lastName}`
    
            // const centerId = userData?.navigation?.center?.id
            // if (!centerId) {
            //     return { success: false, message: '' }
            // }
    
            // const itemId = instrument?.id
            // if (!itemId) {
            //     return { success: false, message: '' }
            // }
            
            // let urlParameters = `?ndhshrksa=${token}&lsjkrnfber=${completeName}&adkenakddwo=${centerId}&urhsbkdnbfsd=${courseId}&pbsgrjskjrae=${itemId}`
            
            // examData = {
            //     method: evaluationMethods.THEORIST,
            //     url: `https://eval.ztudia.com/${urlParameters}`
            // }

        // Inteligencia artificial
        } else if (courseId === 1026 || courseId === 1027 || courseId === 1044 || courseId === 1045 || courseId === 1056 || courseId === 1060 || courseId === 1061 || courseId === 1062 || courseId === 1064 || courseId === 1078 || courseId === 1079 || courseId === 1080 || courseId === 1102 || courseId === 1108 || courseId === 1113) { // ID's para el curso de IA
            examData = await ConfigureExam(evaluationMethods.THEORIST, 'https://eval.ztudia.com', userData, courseId, instrument)
            
        } else {
            examData = {
                method: evaluationMethods.DESKTOP,
                url: null
            }
        }

        return { success: true, data: examData }
    } catch (error) {
        await LogErrors('GetEvaluationMethod - Navigation BL', error)
        return { success: false, message: 'No ha sido posible obtener la información del examen a presentar. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

//----- Ztudent Course Item -----//

export { SaveCourseToShow, ResetCourseToShow, SaveInstrumentToShow, ResetInstrumentToShow, SaveCenterAndRoleToShow, SaveCenterToShow, SaveRoleToShow, ChangeProfile, SaveResultCourseToShow, SaveResultItemToShow, SaveQuickAccessResultToShow, GetAndSetCenterAndRole, GetNickname, GetZtudentDataToGames, SaveGroupToShow, ResetGroupToShow, GetCurrentCenter, GetEvaluationMethod }; //SaveCenterToShow, SaveRoleToShow